export const CASES = {
  UPDATE_WINDOWS: "UPDATE_WINDOWS",
  UPDATE_WINDOWS_SEARCH_FORM: "UPDATE_WINDOWS_SEARCH_FORM",
  UPDATE_WINDOWS_FORM: "UPDATE_WINDOWS_FORM",
  CLEAR_WINDOWS: "CLEAR_WINDOWS",
  CLEAR_WINDOW_FORM: "CLEAR_WINDOW_FORM",
};
